import { render } from "./WeightLossContentEs.vue?vue&type=template&id=30d2eadc&scoped=true"
import script from "./WeightLossContentEs.vue?vue&type=script&lang=js"
export * from "./WeightLossContentEs.vue?vue&type=script&lang=js"

import "./WeightLossContentEs.vue?vue&type=style&index=0&id=30d2eadc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d2eadc"]])

export default __exports__